module.exports = __webpack_public_path__ + "static/media/equity_icon_white.f359086d.svg";